export const MODULES_INFORMATION_APIS = '/api/listModules';

// Export for MODULES_INFORMATION_APIS
export default { MODULES_INFORMATION_APIS };
